export enum NavbarMode {
    CLIENT = 'client',
    FREELANCER = 'freelancer',
    RESOURCES = 'resources',
}

export type ModeConfig = {
    id: NavbarMode;
    page: string;
    prismicDocumentId: string;
};

export type ModuleOptions = {
    modes?: ModeConfig[];
    defaultMode?: NavbarMode;
};

export type ModuleRuntimeConfig = ModuleOptions;
